import React from 'react';
import { noop, isFunction } from 'lodash';
import classnames from 'classnames';
import { useBreakpoints } from '@fiverr-private/business_blocks';
import { I18n } from '@fiverr-private/i18n-react';
import { Icon } from '@fiverr-private/fit';
import { CloseIcon } from '@fiverr-private/icons';
import { Modal as OrcaModal } from '@fiverr-private/orca';
import classes from './index.module.scss';
import { ModalProps } from './types';

const getChildrenWithProps = (children, props) =>
    Array.isArray(children)
        ? children.map((child) => (isFunction(child) ? child(props) : child))
        : [isFunction(children) ? children(props) : children];

export const Modal = ({ className, overlayClassName, onClose = noop, children, ...props }: ModalProps) => {
    const { isSM } = useBreakpoints();

    return (
        <OrcaModal
            overlayClassName={classnames(classes.overlay, overlayClassName)}
            className={classnames(className, { [classes.modalMobile]: !isSM })}
            onClose={onClose}
            {...props}
        >
            {({ close }) => (
                <>
                    <div
                        onClick={close}
                        role="button"
                        className={classnames(classes.closeButton, 'tbody-5 text-semi-bold flex flex-items-center')}
                    >
                        <Icon className={classes.closeIcon} size={16}>
                            <CloseIcon />
                        </Icon>
                        <div className="m-l-8">
                            <I18n k="seller_pages_toolbox.modal.close" />
                        </div>
                    </div>
                    <div className={classes.modal}>{getChildrenWithProps(children, { close })}</div>
                </>
            )}
        </OrcaModal>
    );
};
